import { EventEmitter } from "@angular/core";
import { WorkTimeModel } from "../../shared/models/worktime.model";
import { ColumnModel } from "../../shared/models/column.model";

export class WorkTimeBuildData{
    module = {
        name: "WorkTime",
        new_name: "worktime",
        filtered_name:"WorkTime",
        has_dot_menu: true,
        icon:'fa-pray',
        permission:'work_time'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:WorkTimeModel) => {//Generates Row for codeblack-table
        return WorkTimeModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}